module.exports = __webpack_public_path__ + "media/icons/business-strategy-72e97240.png";